import React, { useState, useEffect } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACTS as DEFAULT_CONTACTS } from "../data/content";
import axios from "axios";

const Contacts = () => {
  const [contacts, setContacts] = useState(DEFAULT_CONTACTS);

  useEffect(() => {
    axios.get("/api/site/content")
      .then((res) => {
        if (res.data?.contacts && Object.keys(res.data.contacts).length > 0) {
          setContacts({ ...DEFAULT_CONTACTS, ...res.data.contacts });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section id="contacts" className="section-y bg-cream-light/60 border-t border-burgundy/20" data-testid="contacts-section">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <h2 className="font-heading text-5xl md:text-7xl text-ink heading-tight">
            Зайдите
            <br />
            <span className="accent text-burgundy">на чашку кофе.</span>
          </h2>
          <p className="mt-8 lede text-ink/85 max-w-md">
            Можно без записи: посмотрим обувь, обсудим задачу и сразу скажем стоимость и сроки.
          </p>

          <ul className="mt-10 space-y-6">
            <li className="flex items-start gap-4" data-testid="contacts-phone-row">
              <span className="w-10 h-10 border border-burgundy/40 flex items-center justify-center text-burgundy shrink-0">
                <Phone size={16} strokeWidth={1.25} />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-muted_ink">Телефон</div>
                <a href={`tel:${contacts.phoneRaw || contacts.phone}`} className="font-heading text-2xl text-ink hover:text-burgundy transition-colors" data-testid="contacts-phone-link">
                  {contacts.phone}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4" data-testid="contacts-email-row">
              <span className="w-10 h-10 border border-burgundy/40 flex items-center justify-center text-burgundy shrink-0">
                <Mail size={16} strokeWidth={1.25} />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-muted_ink">E-mail</div>
                <a href={`mailto:${contacts.email}`} className="font-heading text-2xl text-ink hover:text-burgundy transition-colors break-all" data-testid="contacts-email-link">
                  {contacts.email}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4" data-testid="contacts-address-row">
              <span className="w-10 h-10 border border-burgundy/40 flex items-center justify-center text-burgundy shrink-0">
                <MapPin size={16} strokeWidth={1.25} />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-muted_ink">Адрес</div>
                <p className="font-heading text-2xl text-ink">{contacts.address}</p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-testid="contacts-hours-row">
              <span className="w-10 h-10 border border-burgundy/40 flex items-center justify-center text-burgundy shrink-0">
                <Clock size={16} strokeWidth={1.25} />
              </span>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-muted_ink">Часы работы</div>
                {contacts.hours?.map((h) => (
                  <p key={h.day} className="text-ink">
                    <span className="text-muted_ink">{h.day}:</span>{" "}
                    <span className="font-medium">{h.time}</span>
                  </p>
                ))}
              </div>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border border-burgundy/40 bg-cream-light overflow-hidden">
            <div className="absolute -top-3 -left-3 right-3 bottom-3 border border-burgundy/40 -z-10" />
            <iframe
              title="Карта мастерской Щётка"
              src="https://yandex.ru/map-widget/v1/?ll=34.363731%2C53.243325&z=12&l=map&pt=34.363731%2C53.243325%2Cpm2rdm"
              width="100%"
              height="500"
              frameBorder="0"
              allowFullScreen
              className="block"
              data-testid="contacts-map"
            />
            <div className="px-5 py-4 border-t border-burgundy/40 flex items-center justify-between gap-4 text-xs uppercase tracking-[0.22em] text-muted_ink">
              <span>✦ Карта мастерской ✦</span>
              <a
                href={`https://yandex.ru/maps/?text=${encodeURIComponent(contacts.address)}`}
                target="_blank"
                rel="noreferrer"
                className="text-burgundy hover:underline"
                data-testid="contacts-map-link"
              >
                Открыть в Яндекс.Картах →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
